export const OrganizationType = {
  SystemOwner: "system_owner",
  Partner: "partner",
  Customer: "customer",
} as const

export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType]
